module.exports = __webpack_public_path__ + "img/hot_comm_icon@2x.cfb4d1ed.png";